/* istanbul ignore file */

export function getUrlSearchParamsEntries() {
  return Object.fromEntries(new URLSearchParams(location.search).entries());
}
